/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_DELETEPROJECT, DELETEPROJECT_RECEIVED } = constants.DeleteProjectConstants;

export default {
  REQUEST_DELETEPROJECT,
  DELETEPROJECT_RECEIVED,

  requestDeleteProject: payload => ({
    type: REQUEST_DELETEPROJECT,
    payload
  }),
  DeleteProjectReceived: () => ({
    type: DELETEPROJECT_RECEIVED
  })
};
